function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { massiveSelectRequestsMixin } from '@/apps/data-platform/mixins/massive_select_requests';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import MyPendingsService from '@/apps/data-platform/services/tables_views/my_pendings_service';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW } from '@/js/constants';
import utils from '@/js/utils';
import DialogsComponent from '@/components/DialogsComponent.vue';
import StateComponent from '@/components/StateComponent.vue';
import FormMetadataChangeResponse from '@/components/FormMetadataChangeResponse.vue';
import tasks from '@/js/tasks';
import FormAccessResponse from '@/components/FormAccessResponse.vue';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import { mapState } from 'vuex';
export default {
  name: 'ListTablesAccessRequested',
  mixins: [massiveSelectRequestsMixin],
  components: {
    DialogsComponent: DialogsComponent,
    StateComponent: StateComponent,
    FormMetadataChangeResponse: FormMetadataChangeResponse,
    FormAccessResponse: FormAccessResponse,
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  props: {
    typeFlow: {
      type: String,
      required: false,
      default: ''
    },
    titlePage: {
      type: String,
      required: false,
      default: ''
    },
    isOnlyView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      MODAL_NAME_ACCESS: 'ListTablesAccessRequested',
      MODAL_NAME_METADATA_CHANGE: 'ListTablesMetadataChangeRequested',
      DIALOG_CONFIRM_AUTO_APPROVE: 'DIALOG_CONFIRM_AUTO_APPROVE',
      acccessToAssign: {},
      serverActualMetadata: {},
      // complete when open modal
      queryResponse: {},
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      messageEmptyList: textsDefaul.LOADING,
      filter: '',
      filterOn: [],
      key_meta: 1,
      key_access: 1,
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      },
      total_selected: 0,
      check: true,
      un_check: false,
      table_access: 1,
      status_filter: 'REVISION'
    };
  },
  created: function created() {
    console.log("isviewlistado", this.isOnlyView);
    this.reloadList();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['has_dataplex_catalog_active'])), {}, {
    tableFields: function tableFields() {
      return [{
        text: this.traductor('my_pendings.tablas.source'),
        value: 'source',
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.table'),
        value: 'tableReference.tableId',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.applicant'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.benefited'),
        value: 'benefited',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.request_date'),
        value: 'created_datetime',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.status'),
        value: 'status',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'center'
      }];
    },
    isSelectedItem: function isSelectedItem() {
      var _this = this;
      return function (item) {
        console.log(_this.rows_selected, item);
        _this.rows_selected.forEach(function (x) {
          if (x.id_firestore == item.id_firestore) {
            console.log("encontrado");
            return true;
          }
        });
        console.log("no encontrado");
        return false;
      };
    }
  }),
  watch: {
    rows_selected: function rows_selected(a, b) {
      this.total_selected = this.rows_selected.length;
    }
  },
  methods: {
    onSearch: function onSearch(q, status) {
      this.status_filter = status;
      this.reloadList();
      this.filter = q;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    openRequestAccess: function openRequestAccess(item) {
      var _this2 = this;
      var modalName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // properties: item, index, event
      var modal = modalName || (this.typeFlow == ACCESS_TYPE_FLOW.CHANGE_METADATA ? this.MODAL_NAME_METADATA_CHANGE : this.MODAL_NAME_ACCESS);

      // clone element for work in form modal template
      this.acccessToAssign = utils.cloneJSON(item);
      console.log("change", this.acccessToAssign);
      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;

      // open modal if request is for access or metadata change
      if (this.typeFlow === this.ACCESS_TYPE_FLOW.CHANGE_METADATA) {
        // clean server metadata object local reference
        this.serverActualMetadata = {};
        if (this.has_dataplex_catalog_active) {
          this.acccessToAssign.relativeResourceName = utils.validateEntryNameDataplex(this.acccessToAssign.relativeResourceName, this.acccessToAssign.tableReference.projectId, this.acccessToAssign.tableReference.datasetId, this.acccessToAssign.tableReference.tableId);
        }
        var params = {
          relativeResourceName: this.acccessToAssign.relativeResourceName,
          pageSize: this.PAGE_TAGS_SIZE,
          email: userLogin.email,
          index_node: this.acccessToAssign.index_node,
          domain_table: this.acccessToAssign.domain_table,
          source: this.acccessToAssign.source ? this.acccessToAssign.source : "bigquery"
        };

        // get api original metadata
        AssignmentsService.getListTagEntry(params).then(function (response) {
          console.log("aqui change", response);
          if (response.code === 200) {
            if (response.data.objects._error_ && response.data.objects._error_.code == 403) {
              tasks.toast.error('No se encontró la tabla.');
              return;
            }
            // assign metadata to binding for modal and for request
            _this2.serverActualMetadata = response.data;
            _this2.serverActualMetadata.tableInfo = _this2.acccessToAssign;
            _this2.serverActualMetadata.tipo = 'edicion'; // LINEA AGREGADA
            // open modal metadata change
            // this.$bvModal.show(this.MODAL_NAME_METADATA_CHANGE)
            _this2.key_meta += 1;
            //this.$refs[this.MODAL_NAME_METADATA_CHANGE].onOpen()
            _this2.$refs[modal].onOpen();
          }
        }).catch(function (e) {
          utils.printError(e);
          // this.openRequestAccess(item)
        });
      } else if (this.typeFlow === this.ACCESS_TYPE_FLOW.ACCESS) {
        // open modal access require
        var total_rows = this.acccessToAssign.fields ? this.acccessToAssign.fields.length : 0;
        if (total_rows > envConfig.TABLE_TAGS_LIMIT) {
          if (this.has_dataplex_catalog_active) {
            this.acccessToAssign.relativeResourceName = utils.validateEntryNameDataplex(this.acccessToAssign.relativeResourceName, this.acccessToAssign.tableReference.projectId, this.acccessToAssign.tableReference.datasetId, this.acccessToAssign.tableReference.tableId);
          }
          var _params = {
            relativeResourceName: this.acccessToAssign.relativeResourceName,
            pageSize: this.PAGE_TAGS_SIZE,
            email: userLogin.email,
            index_node: this.acccessToAssign.index_node,
            domain_table: this.acccessToAssign.domain_table,
            source: this.acccessToAssign.source ? this.acccessToAssign.source : "bigquery"
          };

          // get api original metadata
          AssignmentsService.getListTagEntry(_params).then(function (response) {
            if (response.code === 200) {
              var data = response.data.objects.tags ? response.data.objects.tags : [];
              if (data.length > 0) {
                var columns_included = _this2.acccessToAssign.columns_included;
                var columns_dict = {};
                data.map(function (column, index) {
                  if (column.column) {
                    columns_dict[column.column] = index;
                  }
                });
                columns_included.map(function (value) {
                  var colIndex = columns_dict[value];
                  data[colIndex].fields.sensitive['include_in_flow'] = 'INCLUDED';
                });
                _this2.acccessToAssign.fields = data;
              }
              // this.$bvModal.show(this.MODAL_NAME_ACCESS)
              _this2.key_access += 1;
              _this2.$refs[modal].onOpen();
            }
          }).catch(function (e) {
            utils.printError(e);
            _this2.openRequestAccess(item, modalName);
          });
        } else {
          // this.$bvModal.show(this.MODAL_NAME_ACCESS)
          this.key_access += 1;
          this.$refs[modal].onOpen();
        }
      }
    },
    acceptRequestMetadata: function acceptRequestMetadata() {
      // properties: item, index, event
      // this.$bvModal.hide(this.MODAL_NAME_METADATA_CHANGE)
      this.$refs[this.MODAL_NAME_METADATA_CHANGE].onClose();
      this.reloadList();
    },
    onConfirmAutoApprove: function onConfirmAutoApprove(confirm) {
      this.$refs[this.DIALOG_CONFIRM_AUTO_APPROVE].onClose();
      if (confirm) {
        this.$refs[this.MODAL_NAME_ACCESS + '_body'].approveAutomatic();
      }
    },
    acceptRequestAccess: function acceptRequestAccess(item) {
      // properties: item, index, event
      // this.$bvModal.hide(this.MODAL_NAME_ACCESS)
      this.$refs[this.MODAL_NAME_ACCESS].onClose();
      this.$refs[this.DIALOG_ADD_ACCESS_REQUEST].onClose();
      this.onRemoveItem(item);
      this.reloadList();
    },
    onCancel: function onCancel() {
      console.log("oncancel");
      this.$refs[this.DIALOG_ADD_ACCESS_REQUEST].onClose();
      this.table_access += 1;
    },
    onCancelModal: function onCancelModal() {
      this.table_access += 1;
    },
    refuseRequest: function refuseRequest(objectToCRefuse) {
      var _this3 = this;
      var refuseToSend = utils.cloneJSON(objectToCRefuse);
      var params = {
        response: refuseToSend.response,
        id_firestore: refuseToSend.id_firestore,
        domain_table: refuseToSend.domain_table
      };
      MyPendingsService.reject(params).then(function (response) {
        if (response.success) {
          tasks.toast.success('Solicitud rechazada correctamente.');
          // this.$bvModal.hide(this.MODAL_NAME_ACCESS)
          _this3.$refs[_this3.MODAL_NAME_ACCESS].onClose();
          _this3.$refs[_this3.DIALOG_ADD_ACCESS_REQUEST].onClose();
          // this.$bvModal.hide(this.MODAL_NAME_METADATA_CHANGE)
          _this3.$refs[_this3.MODAL_NAME_METADATA_CHANGE].onClose();
          _this3.onRemoveItem(objectToCRefuse);
          _this3.reloadList();
        } else {
          tasks.toast.error('No se pudo rechazar la solicitud, intentelo en unos minutos.');
        }
      }).catch(function (e) {
        utils.printError(e);
        //this.refuseRequest(objectToCRefuse)
      });
    },
    reloadList: function reloadList() {
      var _this4 = this;
      // reload list section
      this.table_access += 1;
      console.log(this.typeFlow, this.status_filter);
      var email = window.userInfo.email;
      MyPendingsService.listPendingApproval(this.typeFlow, email, this.status_filter).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.list_approval && response.data.list_approval.length) {
            _this4.queryResponse = response.data || {};
            response.data.list_approval.forEach(function (objeto) {
              // Verifica si el campo "source" no está presente
              if (objeto.benefited === '') {
                objeto.benefited = objeto.applicant;
              }
              if (!objeto.hasOwnProperty('source')) {
                objeto.source = 'bigquery';
              }
            });
            _this4.queryResponse.list_approval = response.data.list_approval;
          } else {
            _this4.messageEmptyList = textsDefaul.NOT_FOUND;
            if (response.data.list_approval && response.data.list_approval.length === 0) {
              _this4.queryResponse = response.data || {};
            }
            _this4.resetPagination();
          }
          _this4.keyTable += 1;
        } else {
          //this.reloadList()
        }
      }).catch(function (e) {
        utils.printError(e);
        //this.reloadList()
      });
    },
    resetPagination: function resetPagination() {
      this.pagination = {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      };
    }
  }
};